export { default } from './HubFooter';



// WEBPACK FOOTER //
// ./src/components/templates/HubFooter/index.js